import { defineMessages } from 'react-intl'

const scope = 'app.containers.NexusTablePage'

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'Nexus',
  },
  count: {
    id: `${scope}.count`,
    defaultMessage: 'Nexus: {displayed} of {total}',
  },
  filters: {
    id: `${scope}.filters`,
    defaultMessage: 'Filters',
  },
})
